import { instructionStageContent } from './instruction-stages';

const stage = instructionStageContent;

export const hi = {
  translation: {
    meta: {
      title: 'मेज़ नेविगेशन',
      description: 'लौ के साथ मेज़ नेविगेशन गेम।',
    },
    auth: {
      failed: 'सत्र शुरू नहीं हो सका',
      failedTitle: 'प्रमाणीकरण विफल',
    },
    instructions: {
      primaryCtaLabel: 'अभी खेलें',
      secondaryCtaLabel: 'कैसे खेलें?',
      stages: {
        '1': stage,
        '2': stage,
        '3': stage,
        '4': stage,
      },
    },
    results: {
      success: {
        scoreLabel: 'आपका स्कोर',
        chipLabel: 'बहुत बढ़िया!',
        headingLeading: 'शाबाश! आपने पूरा किया',
        headingHighlight: ' स्टेज',
        headingTrailing: '',
        subheading: 'आगे के गेम के लिए तैयार रहें।',
        progressLabel: 'प्रगति',
        progressSuffixLabel: 'पूरे गेम',
        ctaLabel: 'जारी रखें',
      },
      failure: {
        scoreLabel: 'आपका स्कोर',
        chipLabel: 'आपने प्रयास किया!',
        headingLeading: 'चिंता न करें, अगले ',
        headingHighlight: ' गेम',
        headingTrailing: ' में फिर से प्रयास करें!',
        subheading: 'अभ्यास करते रहें, आप सफल होंगे!',
        progressLabel: 'प्रगति',
        progressSuffixLabel: 'गेम्स पूरे हुए',
        ctaLabel: 'जारी रखें',
      },
      exitCloseTabHint: 'अब आप इस टैब को सुरक्षित रूप से बंद कर सकते हैं।',
      exitUseAppBackHint: 'अब आप ऐप पर वापस जा सकते हैं।',
    },
    hud: {
      done: 'हो गया',
      skipLevel: 'स्तर छोड़ें',
      settings: 'सेटिंग्स',
      closeSettings: 'सेटिंग्स बंद करें',
      openSettings: 'सेटिंग्स खोलें',
      soundEffects: 'ध्वनि प्रभाव',
      soundOn: 'चालू',
      soundOff: 'बंद',
      controls: 'नियंत्रण',
      controlsOn: 'चालू',
      controlsOff: 'बंद',
      startFresh: 'नया शुरू',
      testing: 'टेस्ट',
      returnHome: 'होम पर वापस',
      level: 'लेवल',
      levelCompleted: 'लेवल पूरा',
      mode: 'मोड',
      demo: 'डेमो',
      preview: 'पूर्वावलोकन',
      time: 'समय',
      disableAnimations: 'एनिमेशन बंद करें',
    },
    controls: {
      hint: 'रास्ता खोजें — स्वाइप करें या WASD / तीर कुंजियाँ उपयोग करें',
    },
    tutorial: {
      tapToContinue: 'जारी रखने के लिए टैप करें',
      steps: {
        ball: 'आपकी गेंद',
        controls: 'तीर नियंत्रण',
        path: 'पोर्टल तक रास्ता',
        zoom: 'पिंच / माउस व्हील से ज़ूम करें',
      },
    },
    app: {
      tiltDetected: 'झुकाव पकड़ा गया!',
      switchToPortrait: 'खेलते रहने के लिए पोर्ट्रेट मोड में स्विच करें',
    },
    offline: {
      connectionLost: 'कनेक्शन टूट गया',
      youAreOffline: 'आप ऑफलाइन हैं',
      message: 'जारी रखने के लिए इंटरनेट आवश्यक है। अपना नेटवर्क जांचें और पुनः प्रयास करें।',
      retry: 'पुनः प्रयास करें',
    },
    common: {
      loading: 'लोड हो रहा है...',
    },
    loading: {
      game: 'गेम लोड हो रहा है',
    },
    demo: {
      noLevelsAdded: 'कोई DEMO स्तर नहीं जोड़े गए',
    },
    toast: {
      secondShort: 'सेक',
      secondsShort: 'सेकंड',
      demoCompleteTitle: 'डेमो पूरा',
      demoCompleteDescription: 'होमपेज पर {seconds} {secondLabel} में स्वतः पुनर्निर्देशित',
      previewCompleteTitle: 'पूर्वावलोकन पूर्ण',
      previewCompleteDescription: 'पूर्वावलोकन स्तर पूरा हुआ... पुनर्निर्देशित किया जा रहा है...',
      redirectDestinationShort: 'होमपेज',
    },
    win: {
      mazeCleared: 'मेज़ पूरा किया!',
      levelComplete: 'लेवल पूरा',
    },
  },
};
